import './Header.css'
import logo from '../img/logo.png'
import { Link } from "react-router-dom";
import { useState ,useEffect} from "react";
import { FaBars, FaTimes } from "react-icons/fa";

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(true);     
  const closeMenu = () => setIsOpen(false);      
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);
  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <a href="/">
          <img src={logo} alt="logo" />
        </a>
      </div>


      <div className="hamburger" onClick={toggleMenu}>
        <FaBars size={28} />
      </div>


      <ul className={`navbar-links ${isOpen ? "active" : ""}`}>
      
        <li className="menu-close" onClick={closeMenu}>
          <FaTimes size={28} />
        </li>

        <li><a href="/product" onClick={closeMenu}>Product</a></li>
        <li><a href="/service" onClick={closeMenu}>Services</a></li>
        <li><a href="/portfolio" onClick={closeMenu}>Portfolio</a></li>
        <li><a href="/book" onClick={closeMenu}>Contact</a></li>
        <li><a href="/about" onClick={closeMenu}>About Us</a></li>
      </ul>
    </nav>
  )
}

export default Header;
